import React, { useState } from "react";
import { FaEnvelope, FaPhone, FaLinkedin, FaGithub } from "react-icons/fa";
import emailjs from "emailjs-com";
import "../../styles/components/Contact.css";
import { useLanguage } from "../../hooks/LanguageContext";

emailjs.init("rk9LPtv7pxF-aPg0I");

function Contact() {
  const { isEnglish } = useLanguage();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSending, setIsSending] = useState(false);
  const [sendSuccess, setSendSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorFields, setErrorFields] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorFields((prev) => ({ ...prev, [name]: false }));
    setSendSuccess(false);
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    let invalidEmail = false;
    const newErrorFields = {};

    for (const field in formData) {
      if (!formData[field].trim()) {
        newErrorFields[field] = true;
        hasError = true;
      }
    }

    if (formData.email && !isValidEmail(formData.email)) {
      invalidEmail = true;
      hasError = true;
      newErrorFields.email = true;
    }

    setErrorFields(newErrorFields);

    if (hasError) {
      setErrorMessage(
        invalidEmail
          ? isEnglish
            ? "Please enter a valid email address."
            : "Por favor, introduce un correo electrónico válido."
          : isEnglish
            ? "Please fill in all fields."
            : "Por favor, rellena todos los campos."
      );
      return;
    }

    setIsSending(true);
    setErrorMessage("");

    emailjs
      .send(
        "service_tdbn04g",
        "template_hgjaujx",
        {
          user_name: formData.name,
          user_email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        "rk9LPtv7pxF-aPg0I"
      )
      .then(() => {
        setIsSending(false);
        setSendSuccess(true);
        setFormData({ name: "", email: "", subject: "", message: "" });
        setErrorFields({});
      })
      .catch(() => {
        setIsSending(false);
        setErrorMessage(
          isEnglish
            ? "There was an error sending the message. Please try again later."
            : "Hubo un error al enviar el mensaje. Inténtalo de nuevo más tarde."
        );
      });
  };

  return (
    <div className="contact-container page-atmosphere">
      <header className="contact-header">
        <h2 className="contact-heading">
          {isEnglish ? "Let's talk" : "Hablemos"}
        </h2>
        <p className="contact-description">
          {isEnglish
            ? "Have a question or a proposal? Send me a message or reach out through my networks."
            : "¿Tienes una pregunta o propuesta? Envíame un mensaje o contacta a través de mis redes."}
        </p>
      </header>

      {errorMessage && (
        <p className="error-message" role="alert">
          {errorMessage}
        </p>
      )}
      {sendSuccess && (
        <p className="success-message" role="status">
          {isEnglish
            ? "Message sent successfully!"
            : "¡Mensaje enviado con éxito!"}
        </p>
      )}

      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <input
          type="text"
          name="name"
          placeholder={isEnglish ? "Name" : "Nombre"}
          value={formData.name}
          onChange={handleChange}
          className={`form-input ${errorFields.name ? "error" : ""}`}
          autoComplete="name"
        />
        <input
          type="email"
          name="email"
          placeholder={isEnglish ? "Email" : "Correo electrónico"}
          value={formData.email}
          onChange={handleChange}
          className={`form-input ${errorFields.email ? "error" : ""}`}
          autoComplete="email"
        />
        <input
          type="text"
          name="subject"
          placeholder={isEnglish ? "Subject" : "Asunto"}
          value={formData.subject}
          onChange={handleChange}
          className={`form-input ${errorFields.subject ? "error" : ""}`}
        />
        <textarea
          name="message"
          placeholder={isEnglish ? "Write your message" : "Escribe tu mensaje"}
          value={formData.message}
          onChange={handleChange}
          className={`form-textarea ${errorFields.message ? "error" : ""}`}
          rows={6}
        />
        <button type="submit" className="form-button" disabled={isSending}>
          {isSending
            ? isEnglish
              ? "Sending…"
              : "Enviando…"
            : isEnglish
              ? "Send message"
              : "Enviar mensaje"}
        </button>
      </form>

      <div className="contact-info">
        <a
          className="info-item"
          href="mailto:miguelolte2003@gmail.com"
        >
          <FaEnvelope className="contact-icon" />
          <span>miguelolte2003@gmail.com</span>
        </a>
        <a className="info-item" href="tel:+34654306689">
          <FaPhone className="contact-icon" />
          <span>+34 654 306 689</span>
        </a>
        <div className="contact-socials">
          <a
            href="https://www.linkedin.com/in/miguel-olteanu/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/Oltee10"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
